<template>
  <v-app>
    <template v-if="showShell">
      <app-sidebar v-model="drawer" :mini="mini" :unread-count="unreadCount" @logout="logout" />
      <app-topbar :mini="mini" :unread-count="unreadCount" @toggle-nav="toggleNav" @logout="logout" />
    </template>
    <v-main>
      <div :class="showShell ? 'tn-page' : 'tn-auth-page'">
        <router-view></router-view>
      </div>
    </v-main>
    <!-- Short app-wide messages: this.$root.$emit('tn-notify', { color, text }) -->
    <v-snackbar v-model="notice.show" :color="notice.color" :timeout="2500" bottom>{{ notice.text }}</v-snackbar>
  </v-app>
</template>

<script>
import AppSidebar from './components/layout/AppSidebar.vue'
import AppTopbar from './components/layout/AppTopbar.vue'
import { profile, headers, logout, adminNotificationsUnreadCount } from './links'

const MINI_KEY = 'tn.sidebarMini'

function readMini () {
  try {
    return localStorage.getItem(MINI_KEY) === '1'
  } catch (e) {
    return false
  }
}

export default {
  name: 'App',
  components: {
    AppSidebar,
    AppTopbar
  },
  data () {
    return {
      drawer: false,
      mini: readMini(),
      pollInterval: null,
      notice: { show: false, color: 'success', text: '' }
    }
  },
  computed: {
    // Until the first route resolves, $route.name is null: render no shell (avoids a flash on /login).
    showShell () {
      return !!this.$route.name && this.$route.meta.layout !== 'auth'
    },
    unreadCount () {
      return this.$store.state.unreadCount
    }
  },
  watch: {
    showShell: {
      immediate: true,
      handler (val) {
        if (val) this.startPolling()
        else this.stopPolling()
      }
    },
    $route () {
      if (this.showShell) this.fetchUnreadCount()
    }
  },
  methods: {
    toggleNav () {
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.mini = !this.mini
        try {
          localStorage.setItem(MINI_KEY, this.mini ? '1' : '0')
        } catch (e) {
          // Storage blocked (private mode): the choice lasts for this visit only.
        }
      } else {
        this.drawer = !this.drawer
      }
    },
    fetchUnreadCount () {
      if (!localStorage.getItem('token')) return
      this.$http.get(adminNotificationsUnreadCount, { headers: headers(this.$cookies.get('userToken')) })
        .then(res => {
          this.$store.commit('setUnreadCount', res.body.unread_count || 0)
        })
        .catch(() => {})
    },
    startPolling () {
      if (this.pollInterval) return
      this.fetchUnreadCount()
      this.pollInterval = setInterval(this.fetchUnreadCount, 60000)
    },
    stopPolling () {
      clearInterval(this.pollInterval)
      this.pollInterval = null
    },
    logout () {
      const clearSession = () => {
        this.$store.dispatch('removeUser')
        this.$store.commit('setUnreadCount', 0)
        this.$cookies.remove('userToken')
        localStorage.removeItem('token')
        this.stopPolling()
        this.$router.push({ name: 'login' })
      }
      // Leave locally even when the API call fails (e.g. an already expired token).
      this.$http.post(logout, null, { headers: headers(this.$cookies.get('userToken')) }).then(clearSession, clearSession)
    }
  },
  mounted () {
    this.$root.$on('tn-notify', ({ color, text }) => {
      this.notice = { show: true, color: color || 'success', text }
    })
  },
  created () {
    if (!this.$cookies.isKey('userToken')) {
      if (this.$route.name !== 'login') this.$router.push({ name: 'login' })
    } else {
      if (this.$store.state.user === null) {
        this.$http.get(profile, { headers: headers(this.$cookies.get('userToken')) }).then(response => {
          if (response.body.status) {
            this.$store.dispatch('setUser', response.body.data)
          } else {
            this.$store.dispatch('removeUser')
            this.$cookies.remove('userToken')
            this.$router.push({ name: 'login' })
          }
        })
      }
    }
  },
  beforeDestroy () {
    this.stopPolling()
  }
}
</script>

<style>
.inputNumber input[type='number'] {
    -moz-appearance:textfield;
}
.inputNumber input::-webkit-outer-spin-button,
.inputNumber input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>
